import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Tooltip from '@mui/material/Tooltip';
import Announcement from '@mui/icons-material/Announcement';
import QuestionAnswer from '@mui/icons-material/QuestionAnswer';
import LiveHelp from '@mui/icons-material/LiveHelp';

import { orange, grey } from '@mui/material/colors';

const styles = {
    statut0: {
        color: grey[500]
    },
    statut1: {
        color: orange[500]
    }
};

class ReclamationCommentairesPicto extends React.Component {
    render() {
        const { commentaires, classes } = this.props;

        if (commentaires.length === 0) {
            return null;
        }

        var pictos = [];
        for (var i = 0; i < commentaires.length; i++) {

            if (commentaires[i].nombre > 0) {
                switch (commentaires[i].statut) {

                    case 0: pictos.push(<Tooltip key={i} title="Mémo"><Announcement className={classes.statut0} /></Tooltip>); break;
                    case 1: pictos.push(<Tooltip key={i} title="Question(s) sans réponse"><LiveHelp className={classes.statut1} /></Tooltip>); break;
                    case 2: pictos.push(<Tooltip key={i} title="Question(s) avec réponse(s)"><QuestionAnswer className={classes.statut0} /></Tooltip>); break;

                    default: pictos.push(null);
                }
            }
        }
        return (<React.Fragment>{pictos}</React.Fragment>);
    }
}

ReclamationCommentairesPicto.propTypes = {
    commentaires: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ReclamationCommentairesPicto);